import type { en } from '../translations/en'
import type { SourceReaderFunction } from '../types/translationTypes'
import type { Optional } from '../types/types'
import { notEmpty } from './typeUtils'

export const translateBoolean = (
  value: Optional<boolean>,
  translate: SourceReaderFunction<typeof en>,
) => {
  if (notEmpty(value)) {
    return value ? translate('true') : translate('false')
  } else {
    return '-'
  }
}
